import React, { useContext } from 'react';
import { IconLogoGoldie } from '@wds/icons';
import { Immutable } from '@wds/utils';
import { defineMessages, t } from '@sm/intl';
import { generateMetricsAttribute } from '@sm/metrics';

import { useHeaderTheme } from '../../theme';
import useStyles from './useStyles';
import { MomentiveLogo } from './MomentiveLogo';
import { Brand } from '../../types';
import HeaderContext from '../../HeaderContext';

export const COPY = defineMessages({
  LOGO: {
    id: 'Logo.logoLabel',
    defaultMessage: 'Brand logo',
    description:
      '[Type: Label][Vis.: high] - This is the brand logo on the header.',
  },
});

export type LogoProps = Immutable<{
  brand: Brand;
  label?: string;
  link: string;
}>;

export const Logo = ({
  brand = 'SurveyMonkey',
  label = t(COPY.LOGO),
  link,
}: LogoProps): React.ReactElement => {
  const theme = useHeaderTheme();
  const classes = useStyles({ theme });

  const { pageURL, pageURLPath } = useContext(HeaderContext);

  return (
    <span
      className={classes.logo}
      aria-label="logo"
      data-sm-metrics={generateMetricsAttribute({
        data: {
          url: pageURL,
          pageName: pageURLPath,
          amplitudeEvent: 'header clicked navigation',
          navItem: 'logo',
        },
      })}
    >
      <a href={link} className={classes.logo}>
        {brand === 'SurveyMonkey' && <IconLogoGoldie title={label} size="xl" />}
        {brand === 'Momentive' && <MomentiveLogo label={label} />}
      </a>
    </span>
  );
};
